import Product from './Models/Product'

Vue.prototype.$models.$product = new Vue(Product)

Vue.component('products-table', () => import(/* webpackChunkName: "products-table" */ '@modulesPages/Product/Resources/assets/js/Tables/ProductsTable'))

Vue.component('products-form', () => import(/* webpackChunkName: "products-form" */ '@modulesPages/Product/Resources/assets/js/Forms/Products/ProductsForm'))

Vue.component('products-card', () => import(/* webpackChunkName: "products-card" */ '@modulesPages/Product/Resources/assets/js/Cards/ProductsCard'))

Vue.component('new-products-section', () => import(/* webpackChunkName: "new-products-section" */ '@modulesPages/Product/Resources/assets/js/Sections/NewProductsSection'))


Vue.component('product-sizes-table', () => import(/* webpackChunkName: "product-sizes-table" */ '@modulesPages/Product/Resources/assets/js/Tables/ProductSizesTable'))
Vue.component('products-card2', () => import(/* webpackChunkName: "products-card2" */ '@modulesPages/Product/Resources/assets/js/Cards/ProductsCard2'))
Vue.component('product-banner-section', () => import(/* webpackChunkName: "product-banner-section" */ '@modulesPages/Product/Resources/assets/js/Sections/ProductBannerSection'))
Vue.component('related-products-section', () => import(/* webpackChunkName: "related-products-section" */ '@modulesPages/Product/Resources/assets/js/Sections/RelatedProductsSection'))
Vue.component('product-section', () => import(/* webpackChunkName: "product-section" */ '@modulesPages/Product/Resources/assets/js/Sections/Product/ProductSection'))
Vue.component('product-header-section', () => import(/* webpackChunkName: "product-header-section" */ '@modulesPages/Product/Resources/assets/js/Sections/Product/ProductHeaderSection'))
Vue.component('product-share-sidebar', () => import(/* webpackChunkName: "product-share-sidebar" */ '@modulesPages/Product/Resources/assets/js/Sections/Product/ProductShareSidebar'))
Vue.component('product-buyable-section', () => import(/* webpackChunkName: "product-buyable-section" */ '@modulesPages/Product/Resources/assets/js/Sections/Product/ProductBuyableSection'))
Vue.component('product-option-image-modal', () => import(/* webpackChunkName: "product-option-image-modal" */ '@modulesPages/Product/Resources/assets/js/Sections/Product/ProductOptionImageModal'))
Vue.component('product-attribute', () => import(/* webpackChunkName: "product-attribute" */ '@modulesPages/Product/Resources/assets/js/Sections/Product/ProductAttribute'))
Vue.component('products-form2', () => import(/* webpackChunkName: "products-form2" */ '@modulesPages/Product/Resources/assets/js/Forms/Products/ProductsForm2'))
Vue.component('product-buyable-details', () => import(/* webpackChunkName: "product-buyable-details" */ '@modulesPages/Product/Resources/assets/js/Components/ProductBuyableDetails'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Product\\Entities\\Product': 'Producto',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Product\\Entities\\Product': 'products',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'products': 'Modules\\Product\\Entities\\Product',
    }   
}
